import { AuthContextInterface, withAuthContext } from '@amzn/awscat-react-components';
import { Spinner } from '@amzn/awsui-components-react';
import { useEffect, useState } from 'react';
import { Route, RouteProps } from 'react-router-dom';

interface PrivateRouteProps extends RouteProps {
    // eslint:disable-next-line:no-any
    component: any;
}

function PrivateRoute({ auth, component: Component, ...rest }: PrivateRouteProps & AuthContextInterface): JSX.Element {

    const [ isAuthenticated, setIsAuthenticate ] = useState(auth.isAuthenticated());

    useEffect(() => {
        const authenticate = async () => {
            try {
                await auth.authenticate();
                setIsAuthenticate(auth.isAuthenticated());
            } catch (err) {
                console.log(`Auth refreshToken error: ${(err as Error).message}`);
                // if auth.authenticate throws an error it will redirect to the sign-in page
            }
        };
        if (!auth.isAuthenticated()) {
            authenticate();
        }
    });

    return !isAuthenticated ? (
        <Spinner />
    ) : (
        <Route
            {...rest}
            render={(routeProps: any) => {
                return (<Component {...routeProps} />);
            }}
        />
    );
};

export default withAuthContext(PrivateRoute);
